import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Header from "../../Common/Layout/Header";
import HotelDmcTabs from "./HotelDmcTabs";
import "./HotelDashboard.css";

const HotelDashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState([]);
  const [recentEnquiries, setRecentEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterDate, setFilterDate] = useState({
    from: "",
    to: ""
  });

  // Updated Dashboard statistics for Hotels
  const dashboardStats = [
    { title: "Total Enquiries", value: "2,847", icon: "📝", color: "hotel-stat-blue", change: "+15%" },
    { title: "Upcoming Enquiries", value: "156", icon: "📅", color: "hotel-stat-green", change: "+8%" },
    { title: "Pending Enquiries", value: "42", icon: "⏳", color: "hotel-stat-amber", change: "-12%" },
    { title: "Total Bookings", value: "1,196", icon: "✅", color: "hotel-stat-purple", change: "+5%" },
    { title: "Upcoming Bookings", value: "89", icon: "📌", color: "hotel-stat-pink", change: "+22%" },
    { title: "Cancel Bookings", value: "24", icon: "❌", color: "hotel-stat-red", change: "-3%" },
    { title: "Pending Payments", value: "INR 45.8L", icon: "💰", color: "hotel-stat-cyan", change: "+18%" },
  ];

  // Sample recent enquiries data with adults, children, and contact info
  const sampleRecentEnquiries = [
    { 
      id: "ENQ-001", 
      hotel: "Taj Palace", 
      adults: 2, 
      children: 1, 
      roomType: "Deluxe Suite", 
      checkIn: "15 Dec 2023", 
      checkOut: "18 Dec 2023", 
      status: "Confirmed",
      whatsapp: "+911234567890",
      email: "raj@example.com"
    },
    { 
      id: "ENQ-002", 
      hotel: "ITC Grand", 
      adults: 1, 
      children: 0, 
      roomType: "Executive Room", 
      checkIn: "18 Dec 2023", 
      checkOut: "20 Dec 2023", 
      status: "Quoted",
      whatsapp: "+911234567891",
      email: "priya@example.com"
    },
    { 
      id: "ENQ-003", 
      hotel: "Leela Palace", 
      adults: 4, 
      children: 2, 
      roomType: "Presidential", 
      checkIn: "20 Dec 2023", 
      checkOut: "24 Dec 2023", 
      status: "Follow Up",
      whatsapp: "+911234567892",
      email: "amit@example.com"
    },
    { 
      id: "ENQ-004", 
      hotel: "Oberoi", 
      adults: 2, 
      children: 0, 
      roomType: "Premium Room", 
      checkIn: "22 Dec 2023", 
      checkOut: "25 Dec 2023", 
      status: "Cancelled",
      whatsapp: "+911234567893",
      email: "neha@example.com"
    },
    { 
      id: "ENQ-005", 
      hotel: "Radisson Blu", 
      adults: 3, 
      children: 1, 
      roomType: "Standard", 
      checkIn: "25 Dec 2023", 
      checkOut: "27 Dec 2023", 
      status: "Confirmed",
      whatsapp: "+911234567894",
      email: "sanjay@example.com"
    },
  ];

  useEffect(() => {
    // Simulate API call
    setLoading(true);
    setTimeout(() => {
      setStats(dashboardStats);
      setRecentEnquiries(sampleRecentEnquiries);
      setLoading(false);
    }, 500);
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
  };

  const getStatusBadgeClass = (status) => {
    switch(status.toLowerCase()) {
      case 'confirmed':
        return 'hotel-status-confirmed';
      case 'quoted':
        return 'hotel-status-quoted';
      case 'follow up':
        return 'hotel-status-followup';
      case 'cancelled':
        return 'hotel-status-cancelled';
      case 'new':
        return 'hotel-status-new';
      case 'processing':
        return 'hotel-status-processing';
      case 'waiting quote':
        return 'hotel-status-waiting';
      default:
        return 'hotel-status-default';
    }
  };

  const handleWhatsAppClick = (phoneNumber) => {
    const message = `Hello, I'm contacting you regarding your hotel enquiry.`;
    const whatsappUrl = `https://wa.me/${phoneNumber.replace('+', '')}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleEmailClick = (email) => {
    const subject = "Regarding Your Hotel Enquiry";
    const body = `Dear Guest,\n\nWe're following up on your hotel enquiry.`;
    const mailtoUrl = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoUrl;
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterDate(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFilterApply = () => {
    // Filter logic would go here
    console.log("Filtering from:", filterDate.from, "to:", filterDate.to);
  };

  const handleFilterReset = () => {
    setFilterDate({ from: "", to: "" });
  };

  if (loading) {
    return (
      <div id="layout-wrapper">
        <Header User={user} />
        <div className="hotel-loading">
          <div className="hotel-loading-spinner"></div>
          <p>Loading Hotel Dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="card">
              <div className="p-2">
                {/* <HotelDmcTabs pageName="HOTELDASHBOARD" /> */}
              </div>
              <div className="card-body">
                <div className="hoteldashboard-dashboard">
                  <main className="hoteldashboard-main-content-fullscreen">
                    {/* Header */}
                    <header className="hoteldashboard-main-header">
                      <div className="hoteldashboard-header-content">
                        <div className="hoteldashboard-header-title">
                          <h1>Hotel Management Dashboard</h1>
                          <p>Manage hotel properties and enquiries</p>
                        </div>
                        <div className="hoteldashboard-header-actions">
                          <button 
                            className="hotel-action-btn hotel-secondary-btn"
                            onClick={() => handleNavigation('/hotel/reports')}
                          >
                            📊 Reports
                          </button>
                          <button 
                            className="hotel-action-btn hotel-primary-btn"
                            onClick={() => handleNavigation('/hotel/enquiries/create')}
                          >
                            + New Enquiry
                          </button>
                        </div>
                      </div>
                    </header>

                    {/* Stats Grid - 7 cards */}
                    <div className="hotel-stats-grid-seven mb-4">
                      {stats.map((stat, index) => (
                        <div key={index} className={`hotel-stat-card ${stat.color}`}>
                          <div className="hotel-stat-icon-container">{stat.icon}</div>
                          <div className="hotel-stat-value">{stat.value}</div>
                          <div className="hotel-stat-title">{stat.title}</div>
                          <div className={`hotel-stat-change ${stat.change.startsWith('+') ? 'positive' : 'negative'}`}>
                            {stat.change}
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Date Filter Section */}
                    <div className="hotel-date-filter-section">
                      <div className="hotel-filter-title">
                        <h3>📅 Filter Enquiries by Date</h3>
                        <p>View enquiries between specific dates</p>
                      </div>
                      <div className="hotel-filter-controls">
                        <div className="hotel-filter-input-group">
                          <div className="hotel-filter-input">
                            <label htmlFor="fromDate">From Date</label>
                            <input
                              type="date"
                              id="fromDate"
                              name="from"
                              value={filterDate.from}
                              onChange={handleFilterChange}
                              className="hotel-date-input"
                            />
                          </div>
                          <div className="hotel-filter-input">
                            <label htmlFor="toDate">To Date</label>
                            <input
                              type="date"
                              id="toDate"
                              name="to"
                              value={filterDate.to}
                              onChange={handleFilterChange}
                              className="hotel-date-input"
                            />
                          </div>
                        </div>
                        <div className="hotel-filter-buttons">
                          <button 
                            className="hotel-filter-apply-btn"
                            onClick={handleFilterApply}
                          >
                            Apply Filter
                          </button>
                          <button 
                            className="hotel-filter-reset-btn"
                            onClick={handleFilterReset}
                          >
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Main Content Grid */}
                    <div className="hotel-content-grid">
                      {/* Recent Enquiries Table */}
                      <div className="hotel-main-card">
                        <div className="hotel-card-header">
                          <div className="hotel-card-title">
                            <div className="hotel-card-icon hotel-enquiries-icon">
                              📝
                            </div>
                            <div>
                              <h3>Recent Enquiries</h3>
                              <p>Latest hotel enquiries</p>
                            </div>
                          </div>
                          <button 
                            className="hotel-view-all-btn"
                            onClick={() => handleNavigation('/hotel/enquiries')}
                          >
                            View All →
                          </button>
                        </div>
                        
                        <div className="hotel-enquiries-table">
                          <table className="hotel-table">
                            <thead>
                              <tr>
                                <th>Enquiry ID</th>
                                <th>Hotel</th>
                                <th>Guests</th>
                                <th>Room Type</th>
                                <th>Check-in</th>
                                <th>Check-out</th>
                                <th>Status</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {recentEnquiries.map((enquiry, index) => (
                                <tr key={index} className="hotel-table-row">
                                  <td>
                                    <div className="hotel-enquiry-id">
                                      <span className="hotel-id-badge">{enquiry.id}</span>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="hotel-hotel-info">
                                      <div className="hotel-hotel-name">{enquiry.hotel}</div>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="hotel-guests-info">
                                      <div className="hotel-guests-count">
                                        <span className="hotel-adults-count">👤 {enquiry.adults}</span>
                                        {enquiry.children > 0 && (
                                          <span className="hotel-children-count">👶 {enquiry.children}</span>
                                        )}
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="hotel-room-type">
                                      <div className="hotel-room-label">{enquiry.roomType}</div>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="hotel-checkin-info">
                                      <div className="hotel-checkin-date">{enquiry.checkIn}</div>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="hotel-checkout-info">
                                      <div className="hotel-checkout-date">{enquiry.checkOut}</div>
                                    </div>
                                  </td>
                                  <td>
                                    <span className={`hotel-status-badge ${getStatusBadgeClass(enquiry.status)}`}>
                                      {enquiry.status}
                                    </span>
                                  </td>
                                  <td>
                                    <div className="hotel-action-buttons">
                                      <button 
                                        className="hotel-whatsapp-btn"
                                        onClick={() => handleWhatsAppClick(enquiry.whatsapp)}
                                        title="Contact via WhatsApp"
                                      >
                                        <span className="hotel-whatsapp-icon">💬</span>
                                      </button>
                                      <button 
                                        className="hotel-email-btn"
                                        onClick={() => handleEmailClick(enquiry.email)}
                                        title="Send Email"
                                      >
                                        <span className="hotel-email-icon">✉️</span>
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </main>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HotelDashboard;